export default __webpack_public_path__ + "static/media/1827.c6f1bf4a.png";